import { Collapse, HTMLChakraProps, forwardRef } from '@chakra-ui/react-v2';
import { chakra } from '@chakra-ui/react-v2';

import { useThinkingContext } from '../ThinkingContext';
import { useThinkingStyles } from '../useThinkingStyles';

export type ThinkingExpandedContentProps = HTMLChakraProps<'div'>;

export const ThinkingExpandedContent: React.FC<ThinkingExpandedContentProps> =
  forwardRef<ThinkingExpandedContentProps, 'p'>(
    ({ children, ...props }, ref) => {
      const { expandedContent } = useThinkingStyles();
      const { isExpanded } = useThinkingContext();

      return (
        <Collapse in={isExpanded} animateOpacity={false}>
          <chakra.div
            sx={expandedContent}
            className="thinking-expanded-content"
            data-expanded={isExpanded}
            {...props}
            ref={ref}
          >
            {children}
          </chakra.div>
        </Collapse>
      );
    },
  );
